import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const TENUE_URL = `${backendUrl}/api/tenue/`;

class TenueService {
	async getAllTenues() {
		try {
			const response = await axios.get(TENUE_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getTenue(id) {
		return axios.get(`${TENUE_URL}${id}/`);
	}

	createTenue(data) {
		return axios.post(TENUE_URL, data).catch((error) => {
			console.error('Erreur lors de la création du parent', error);
			throw error;
		});
	}

	updateTenue(id, data) {
		return axios.put(`${TENUE_URL}${id}/`, data);
	}

	deleteTenue(id) {
		return axios.delete(`${TENUE_URL}${id}/`);
	}

	getTenueOptions() {
		return this.getAllTenues().then((Tenues) => {
			const options = Tenues.map((Tenue) => ({
				value: Tenue.id,
				label: (Tenue.titre + ' ').toUpperCase()
			}));
			return options;
		});
	}
}

export default new TenueService();
